<div class="content-layout" [brightsideWebFb]="{event_name: 'mpap welcome'}">
  <bw-action-article-legacy>
    <ui-nav-exit-back header-actions [trackingDetail]="{ event_name: 'mpap_welcome_dismissed' }"></ui-nav-exit-back>

    <div header-title>
      <typography-legacy title-large color="var(--primary-text)" class="mb-sm">
        {{ 'MPAP_INTRO_TITLE' | translate }}
      </typography-legacy>
    </div>
    <div content-section>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_INTRO_SECTION1_DESC' | translate"></div>
        <ul>
          <li [innerHTML]="'MPAP_INTRO_BULLET1' | translate"></li>
          <li [innerHTML]="'MPAP_INTRO_BULLET2' | translate"></li>
        </ul>
        <div [innerHTML]="'MPAP_INTRO_SECTION2_DESC' | translate"></div>
      </bw-paragraph-legacy>
      <div class="flex mb-sm">
        <div class="flex-row">
          <bw-icon-legacy class="mr-xs" iconName="lightbulb" color="var(--brand)" backgroundColor="var(--bg-gray)"></bw-icon-legacy>
          <typography-legacy title-medium>
            {{ 'MPAP_INTRO_SECTION1_TITLE' | translate }}
          </typography-legacy>
        </div>
      </div>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_1' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_1_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_2' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_2_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_3' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_3_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_4' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_4_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_5' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_5_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_6' | translate }}
      </typography-legacy>
      <img width="400" src="/assets/MPAP-incomeGuidelines2023.png">
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_6_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_7' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_7_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_8' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_8_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_9' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_9_DESC' | translate"></div>
      </bw-paragraph-legacy>

      <typography-legacy text-medium-semibold class="mb-sm">
        {{ 'MPAP_FAQ_10' | translate }}
      </typography-legacy>
      <bw-paragraph-legacy>
        <div [innerHTML]="'MPAP_FAQ_10_DESC' | translate"></div>
      </bw-paragraph-legacy>
    </div>
    <button *ngIf="displayCta"
      bw-button-legacy
      footer-actions
      [processing]="processing"
      [brightsideWebFb]="{event_name: 'mpap welcome'}"
      (click)="handleClick();">{{ ctaButtonInfo.ctaKey | translate }}</button>
  </bw-action-article-legacy>
</div>
